export const defaultCardWidth = 175;
export const defaultCardHeight = 120;

export const defaultContainerWidth = defaultCardWidth * 2 + 13;
export const defaultContainerWidthTablet = defaultCardWidth * 3 + 26;
export const defaultContainerWidthDesktop = defaultCardWidth * 4 + 46;
